export default __webpack_public_path__ + "static/btut-d33c22b5d590f1c1203e3b40e0dd4ead.mp4";